import { render, staticRenderFns } from "./SelectKeyword.vue?vue&type=template&id=4157be3e&scoped=true&"
import script from "./SelectKeyword.vue?vue&type=script&lang=ts&"
export * from "./SelectKeyword.vue?vue&type=script&lang=ts&"
import style0 from "./SelectKeyword.vue?vue&type=style&index=0&id=4157be3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157be3e",
  null
  
)

export default component.exports